module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/bg-01-b22c7fd6881d7f241542f24673c659a9.png";